import { find, findAll, register } from '../../../../Javascript/Sysmex/Utils'
/* eslint-disable */
import { Luminous } from '../../../../Javascript/Libraries/Luminous'

const ImageLightbox = el => {
  let captionText = ''
  const images = findAll('[data-component="ImageLightbox"] a', el)
  const titleText = find('img', el).getAttribute('title')

  const luminousOptions = {
    caption: (el) => {
      if (find('img', el).getAttribute('data-caption') != null) {
        captionText = find('img', el).getAttribute('data-caption')
      } else if ((el.nextElementSibling && el.nextElementSibling.classList.contains('imageCaption')) || (el.nextElementSibling && el.nextElementSibling.tagName === 'figcaption')) {
        captionText = el.nextElementSibling.textContent.trim()
      } else {
        captionText = titleText != null && titleText !== 'true' ? titleText : ''
      }
      return captionText
    },
    title: (el) => {
      return find('img', el).getAttribute('title') != null && find('img', el).getAttribute('title') !== 'true' ? find('img', el).getAttribute('title') : '' // necessary to return empty string because IE11 will print out the null
    }
  }
  const luminousGalleryOptions = {
    arrowNavigation: images.length > 1
  }
  /* eslint-disable */
  new LuminousGallery(images, luminousGalleryOptions, luminousOptions)
}

register('ImageLightbox', ImageLightbox)

